import { ForgotPasswordWrapper } from "./styled"
import Button from "components/Button"
import Input from "components/Input"
import { authSelector } from 'redux/selector'
import { authAction } from "redux/slice/authSlice"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import ShowToast from "utils/ShowToast"
import { useFormik } from "formik"
import * as Yup from "yup"
import { authError } from "errors/auth"
import Loading from "components/Loading"
import { appURL } from "utils/index"

const ForgotPassword = () => {
    const authState = useSelector(authSelector)
    const dispatch = useDispatch()
    const formData = useFormik({
        initialValues: {
            email: "",
        },
        validateOnBlur: false,
        validateOnChange: false,
        validationSchema: Yup.object({
            email: Yup.string().trim().required(authError.requiredEmail).email(authError.invalidEmail),
        }),
        onSubmit: (values, { setFieldError }) => {
            values.app_url = `${appURL}reset-password`
            if (!authState.isFetching)
                dispatch(authAction.forgotPassword({ values, setFieldError, ShowToast }))
        }
    })

    return (
        <ForgotPasswordWrapper className="flex-center pt-35">
            {
                authState.isFetching && <Loading />
            }
            <form onSubmit={formData.handleSubmit}>
                <h1 className="text-black s-24 bold text-center mb-50">QUÊN MẬT KHẨU</h1>
                <div className="form-input mb-25">
                    <Input
                        placeholder="Email"
                        name="email"
                        value={formData.values.email}
                        isError={!!formData.errors.email}
                        message={formData.errors.email}
                        onChange={formData.handleChange}
                    />
                </div>

                <Button className="action-danger-1 btn-forgot" type="submit" isNa={authState.isFetching}>Quên mật khẩu</Button>
                <div className="mt-25 flex-end">
                    <Link to="/login" className="text-link s-16 text-link-hover ">Trở về đăng nhập</Link>
                </div>
            </form>
        </ForgotPasswordWrapper>
    )
}

export default ForgotPassword